<template>
  <div class="newRest">
    <div class="eventName">{{eventName}}</div>
    <editBox :btnHide="true">
      <div class="infoCol infoColEdit">
        <div>報名日期</div>
        <div>
          <vue-ctk-date-time-picker :range="false" v-model="item.date"
          class="getDate"
          :only-date="true"
          :color="'var(--color-pri)'"
          :no-label="true"
          :auto-close="true"
          :input-size="'sm'"
          :min-date="moment().add(1, 'day').format('YYYY-MM-DD')"
          :format="'YYYY-MM-DD'"
          :formatted="'YYYY-MM-DD'"
          :label="'請選擇日期'"/>
        </div>
      </div>
      <div class="infoCol infoColEdit">
        <div>報名時段</div>
        <div>
          <select v-model="item.session">
          <option :value="null">請選擇時段</option>
          <option v-for="(ev, i) in sessions" :key="`ses-${i}`" :value="ev">{{ev}}</option>
        </select>
        </div>
      </div>
      <div class="infoCol infoColEdit">
        <div>預約人</div>
        <div><input type="text" v-model="item.field_name"></div>
      </div>
      <div class="infoCol infoColEdit">
        <div>聯絡電話</div>
        <div><input type="text" v-model="item.field_tel"></div>
      </div>
      <div class="infoCol infoColEdit">
        <div>居住縣市</div>
        <div>
          <input type="text" v-model="item.field_city" placeholder="縣市" :style="{width: '200px'}" list="cities">
          <datalist id="cities">
            <option v-for="(cty, i) in countries" :key="`country-${i}`" :value="cty">{{cty}}</option>
          </datalist>
        </div>
      </div>
    </editBox>
    <editBoxH label="報名人數" :btnHide="true">
      <div class="infoCol infoColEdit nums">
        <div>預約人數</div>
        <div :style="{display: 'flex', gap: '15px', alignItems: 'center'}">
          <input :style="{width: '75px'}" type="text" v-model.number="item.reserveNum"><div>大</div>
          <input :style="{width: '75px'}" type="text" v-model.number="item.reserveNumChild"><div>小</div>
        </div>
      </div>
      <hr class="hrdeco">
      <div :style="{display: 'flex', paddingLeft: '20px', paddingRight: '10px',justifyContent: 'flex-end'}">
        <div>總人數 <span :style="{color: '#E37878', fontSize: '28px', fontWeight: '900', marginInline: '.5em'}">{{item.reserveNum + item.reserveNumChild}}</span> 人</div>
      </div>
    </editBoxH>
    <editBoxH label="備註" :btnHide="true">
      <textarea v-model="item.field_remark" :style="{height: '200px'}"></textarea>
    </editBoxH>
    <editBoxH label="業務經辦(員工)" :btnHide="true">
      <div class="infoCol infoColEdit">
        <div>業務來源</div>
          <Select  :defaultValue="item.source" @input="item.source=$event" class="salesman" :width="'230px'">
            <option :value="null"></option>
            <option v-for="(sman, i) in sources" :key="`sman-${i}`" :value="sman.key">
              {{sman.key}}</option>
          </Select>
      </div>
      <div class="infoCol infoColEdit">
        <div>業務經辦</div>
          <Select :defaultValue="item.salesman" @input="item.salesman=$event" class="salesman" :width="'230px'">
            <option :value="null"></option>
            <option v-for="(sman, i) in salesmans" :key="`sman-${i}`" :value="sman._id">
              {{sman.department}} | {{sman.post}} | {{sman.name}}</option>
          </Select>
      </div>
    </editBoxH>
    <div class="btns">
      <button class="cancel" @click="$emit('close')">取消</button>
      <button class="confirm" @click="save" :disabled="!vaild">儲存</button>
    </div>
  </div>
</template>

<script>
import { getapi, putapi } from '../../../store/fetch'
import Select from '../../../components/select.vue'
import editBox from '../../../components/editBox'
import editBoxH from '../../../components/editBoxWithHeader'
export default {
  props: ['addTeam', 'sessions', 'eventType', 'eventId', 'eventName'],
  components: {
    editBox,
    editBoxH,
    Select
  },
  data () {
    return {
      item: {
        date: this.moment().add(1, 'day').format('YYYY-MM-DD'),
        session: this.moment().format('HH:mm'),
        visitDate: null,
        field_name: null,
        field_tel: null,
        field_email: null,
        field_city: null,
        field_remark: null,
        reserveNum: 0,
        reserveNumChild: 0,
        salesman: null,
        source: '自來電'
      },
      salesmans: [],
      countries: [],
      sources: []
    }
  },
  computed: {
    vaild () {
      return this.item.date && this.item.session && this.item.field_name && this.item.field_tel && this.item.reserveNum !== null
    }
  },
  async mounted () {
    this.countries = await getapi('selections/country')
    this.sources = await getapi('selections/sourceEvent')
    const salesmans = await getapi('users/local/short')
    this.salesmans = salesmans
  },
  methods: {
    async save () {
      const data = { event: this.eventId, ...this.item }
      data.visitDate = this.moment(data.date).toDate()
      const r = await putapi('events', data)
      if (r) {
        this.$emit('new', r)
        this.$emit('close')
      }
    }
  }
}
</script>
<style lang="scss">
.newRest {
  .date-time-picker .field::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 36px;
    height: 36px;
    -webkit-mask-size: contain;
    mask-size: contain;
    background-color: var(--color-checked);
    -webkit-mask-size: 22px;
    mask-size: 22px;
    -webkit-mask-image: url(/calendar2.svg);
    mask-image: url(/calendar2.svg);
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
  }
  margin-block: 20px;
  textarea {
    border: none;
    min-height: 140px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    letter-spacing: 0.1em;
  }
  .editBoxContent {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
}
</style>

<style lang="scss">
.eventName {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 35px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  text-align: start;

}
.newRest {
  .datetimepicker {
    right: 0;
  }
  .date-time-picker.getTime {
    height: 40px;
    width: 200px;
    .field {
      height: 40px;
      width: 200px;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 36px;
        height: 40px;
        mask-size: contain;
        background-color: var(--color-checked);
        mask-size: 22px;
        mask-image: url(/clock.svg);
        // background-image: url(/calendar.svg);
        mask-repeat: no-repeat;
        mask-position: center;
      }
    }
    .field-input {
      height: 40px;
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 18px!important;
      letter-spacing: 0.1em;
      color: var(--color-letter);
      // background: url(/calendar.svg) center/90% no-repeat;
      opacity: 1;
      background-position: calc(100% - 10px);
      background-size: 20px;
      padding-top: 6px;
      padding-right: 40px;
      &::placeholder {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        letter-spacing: 0.1em;
      }
    }
    .custom-button.round {
      margin-right: 30px;
    }
  }
  .date-time-picker.getDate {
    height: 40px;
    width: 200px;
    .field {
      height: 40px;
      width: 200px;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 36px;
        height: 40px;
        mask-size: contain;
        background-color: var(--color-checked);
        mask-size: 22px;
        mask-image: url(/calendar2.svg);
        // background-image: url(/calendar.svg);
        mask-repeat: no-repeat;
        mask-position: center;
      }
    }
    .field-input {
      height: 40px;
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 18px!important;
      letter-spacing: 0.1em;
      color: var(--color-letter);
      // background: url(/calendar.svg) center/90% no-repeat;
      opacity: 1;
      background-position: calc(100% - 10px);
      background-size: 20px;
      padding-top: 6px;
      padding-right: 40px;
      &::placeholder {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        letter-spacing: 0.1em;
      }
    }
    .custom-button.round {
      margin-right: 30px;
    }
  }
}
</style>
<style lang="scss" scoped>
hr {
  height: 1px;
  width: 100%;
  background-color: #CACACA;
  margin-block: .5em;
}
.nums {
  input[type=text] {
    text-align: center;
    padding-inline: 0!important;
  }
}
.selectAgency {
  position: fixed;
  left: -374px;
  bottom: 47px;
  z-index: -1;
  display: flex!important;
  flex-direction: column;
  width: 370px;
  transform: translateX(calc(100% + 15px));
  min-height: 550px;
  max-height: 550px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px 0px 0px 10px;
  background-color: #FFFFFF;
  input {
    height: 35px;
    border: 1px solid #C4C4C4;
    box-sizing: border-box;
    border-radius: 3px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    text-align: start;
    color: var(--color-letter);
    width: -webkit-fill-available;
    padding-inline: .5em;
  }
  &>div:nth-child(1) {
    width: 100%;
    padding-inline: 36px;
    padding-top: 24px;
    padding-bottom: 10px;
    height: fit-content;
    box-sizing: border-box;
  }
  &>div:nth-child(2) {
    overflow-y: scroll;
    margin-inline: 16px;
    padding-inline: 19px;
    margin-bottom: 10px;
    height: fit-content;
    display: flex;
    flex-direction: column;
    &::-webkit-scrollbar {
      width: 7px;
      background-color: #F5F5F5;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 20px;
      box-shadow: inset 0 0 6px #0000004d;
      background-color: var(--color-checked);
    }
    &::-webkit-scrollbar-track {
      border-inline: 2px solid transparent!important;
      // border: 3px solid transparent;
      background-color: #d8d8d8;
      border-radius: 20px;
      width: 7px;
      box-sizing: border-box;
      border: 2px solid #FFFFFF!important;
    }
    &>div {
      width: 100%;
      font-family: Noto Sans TC;
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      letter-spacing: 0.1em;
      color: var(--color-letter);
      height: 50px;
      min-height: 50px;
      text-align: start;
      display: flex;
      align-items: center;
      &.checked {
        background-color: #E9F5FC;
      }
      &:hover {
        background-color: #E9F5FC;
      }
    }
  }
}
.agencyID {
  display: flex;
  &>div {
    box-sizing: border-box;
    width: 200px;
    height: 40px;
    border: 1px solid #C4C4C4;
    border-radius: 3px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    display: flex;
    align-items: center;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    padding-inline: 12px;
    text-align: start;
    white-space: nowrap;
    flex-wrap: nowrap;
    overflow-x: hidden;
  }
  &>button {
    width: 40px;
    height: 40px;
    background-color: var(--color-checked);
    mask-image: url(/selectbox.svg);
    mask-size: cibntain;
    mask-position: center;
    mask-repeat: no-repeat;
    border: none;
  }
}
.slide-in {
    animation: slide-in 0.5s forwards;
    -webkit-animation: slide-in 0.5s forwards;
}
.slide-out {
    animation: slide-out 0.5s forwards;
    -webkit-animation: slide-out 0.5s forwards;
    animation-delay: -0.2s;

}

@keyframes slide-in {
    0% { transform: translateX(calc(100% + 15px)); }
    100% { transform: translateX(2px); }
}

@-webkit-keyframes slide-in {
    0% { transform: translateX(calc(100% + 15px)); }
    100% { transform: translateX(2px); }
}

@keyframes slide-out {
    50% { transform: translateX(0%); }
    100% { transform: translateX(calc(100% + 15px));  }
}

@-webkit-keyframes slide-out {
    50% { -webkit-transform: translateX(0%); }
    100% { -webkit-transform: translateX(calc(100% + 15px)); }
}
.addnewOrders {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  &>button {
    height: 50px;
    width: 150px;
    border-radius: 25px;
    border: none;
    background-color: var(--color-checked);
    color: #FFFFFF;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    letter-spacing: 0.1em;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2px;
    &::before {
      content: '';
      display: inline-block;
      margin-block: 12.5px;
      width: 25px;
      height: 25px;
      background-repeat: no-repeat;
      background-image: url(/add.svg);
    }
    &::after {
      content: '新增餐點';
      display: inline-block;
      line-height: 25px;
      margin-block: 12.5px;
      height: 25px;
    }
  }
}
.infoColEdit {
  height: 60px;
  box-sizing: border-box;
  &>:nth-child(2)>input[type=text], &>:nth-child(2)>select {
    height: 40px;
    box-sizing: border-box;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    padding-left: 14px;
    border: 1px solid #C4C4C4;
    border-radius: 3px;
    box-sizing: border-box;
  }
  &>:nth-child(2)>input {
    color: var(--color-letter);
  }
  &>:nth-child(2)>select {
    color: var(--color-checked);
  }
  &:nth-child(1)>:nth-child(2)>input, &:nth-child(1)>:nth-child(2)>select { width: 201px; }
  &:nth-child(2)>:nth-child(2)>input, &:nth-child(2)>:nth-child(2)>select { width: 175px; }
  &:nth-child(4)>:nth-child(2)>input, &:nth-child(4)>:nth-child(2)>select { width: 175px; }
  &:nth-child(5)>:nth-child(2)>input, &:nth-child(5)>:nth-child(2)>select { width: 247px; }
  &:nth-child(6)>:nth-child(2)>input, &:nth-child(6)>:nth-child(2)>select { width: 201px; }
  &:nth-child(7)>:nth-child(2)>input, &:nth-child(7)>:nth-child(2)>select { width: 70px; }
  &:nth-child(8)>:nth-child(2)>input, &:nth-child(8)>:nth-child(2)>select { width: 70px; }
  &:nth-child(9)>:nth-child(2)>input, &:nth-child(9)>:nth-child(2)>select { width: 70px; }
  input[type=text] {
    box-sizing: border-box;
  }
  input[type=radio] {
    appearance: none;
    filter: contrast(.4);
    margin-right: 20px;
    &.none {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &.none::before {
      content: '🞭';
      font-size: 22px;
    }
    &:checked {
      filter: none;
    }
  }
}
.infoCol {
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 29px;
  text-align: right;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 27px;
  height: 40px;
  &>div:nth-child(1) {
    width: 90px;
    min-width: 90px;
    display: inline-flex;
    justify-content: flex-end;
    align-items: flex-start;
  }
  &>div:nth-child(2) {
    display: inline-flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
.btns{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #E37878;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}
select.salesman {
  width: 300px;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #C4C4C4;
  box-sizing: border-box;
  border-radius: 3px;
  justify-self: flex-start;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  padding-inline: 12px;
  margin-bottom: 12px;
}
div.salesman {
  width: 100%;
  display: flex;
  align-items: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  padding-inline: 10px;
}
.hrdeco {
  height: 12px;
  width: 100%;
  background-color: var(--color-pri);
  mask-image: url(/hrdeco.svg);
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
  border: none;
  margin: 0;
}
.sets {
  display: flex;
  height: fit-content;
  gap: 0px;
  &>div:nth-child(1) {
    display: flex;
    flex-direction: column;
    width: 60px;
    align-items: center;
    box-sizing: border-box;
    input[type=text] {
      box-sizing: border-box;
      width: 60px;
      height: 35px;
      font-family: 'Noto Sans TC';
      font-style: normal;
      font-weight: 500;
      font-size: 24px;
      display: flex;
      align-items: center;
      text-align: center;
      letter-spacing: 0.1em;
      vertical-align: middle;
      color: var(--color-checked);
    }
    &>div:nth-child(1)>div, &>div:nth-child(3)>div {
      display: flex;
    }
    &>div:nth-child(1)>div:nth-child(1)>button {
      height: 20px;
      width: 28px;
      border: none;
      background-color: var(--color-checked);
      mask-image: url(/up.svg);
      mask-repeat: no-repeat;
      mask-position: center;
    }
    &>div:nth-child(1)>div:nth-child(3)>button {
      height: 20px;
      width: 28px;
      border: none;
      background-color: var(--color-checked);
      mask-image: url(/up.svg);
      mask-repeat: no-repeat;
      mask-position: center;
      transform: rotate(180deg);
    }
  }
  &>div:nth-child(2) {
    padding-left: 10px;
    text-align: start;
    width: -webkit-fill-available;
    &>div:nth-child(1) {
      font-family: 'Noto Sans TC';
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      letter-spacing: 0.1em;
      color: #5E5E5E;
      padding-top: 21px;
      margin-bottom: 6px;
    }
    &>div:nth-child(2) {
      padding-left: 1.2em;
      display: flex;
      flex-direction: column;
      gap: 12px;
      font-family: 'Noto Sans TC';
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      color: var(--color-checked);
    }
  }
  &>div:nth-child(3) {
      padding-left: 10px;
      font-family: 'Noto Sans TC';
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      letter-spacing: 0.1em;
      color: #5E5E5E;
      padding-top: 21px;
      position: relative;
      .delbtn {
        position: absolute;
        bottom: 0;
        background-color: #E37878;
        width: 44px;
        height: 44px;
        border: none;
        border-radius: 50%;
        right: 0;
        &::before {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #FFFFFF;
          content: '';
          mask-image: url(/delete.svg);
          mask-position: center;
          mask-repeat: no-repeat;
          mask-size: 20px 22.17px;
        }

      }
  }
}
</style>
